/* eslint-disable */
import { store } from '@/redux/store'
import BasicConfig from '@/config/basic'
import Session from '@/utils/session'
import { parseQueryString, objToSearch, checkToken, saveTokenWithTimestamp } from '@/utils/helpers'
import { appLogin } from '@/redux/app/appSlice'

// 二维码登录
export function redirectLogin (url) {
  const fallBackUrl = url
    .replace('?', 'AAA')
    .replace('#', 'BBB')
    .replace(/&/g, 'CCC')
  window.location.href = `${BasicConfig.loginCodeUrl}?fallBackUrl=${fallBackUrl}`
}

// 构建登录 URL（用于 API 调用）
export function getLoginUrl (fallbackUrl) {
  let baseUrl = BasicConfig.loginShixin
  
  // 判断是否为完整 URL
  const isFullUrl = /^https?:\/\//.test(baseUrl)
  
  // 开发环境或测试环境：basic.js 已经返回相对路径，直接使用
  // 生产环境：basic.js 返回完整 URL（https://erp.duobaby.net），直接使用
  if (isFullUrl) {
    // 生产环境：完整 URL，直接返回
    if (fallbackUrl) {
      const encodedFallbackUrl = fallbackUrl
        .replace('?', 'AAA')
        .replace('#', 'BBB')
        .replace(/&/g, 'CCC')
      const separator = baseUrl.includes('?') ? '&' : '?'
      return `${baseUrl}${separator}fallbackUrl=${encodedFallbackUrl}`
    }
    return baseUrl
  }
  
  // 相对路径（开发环境或测试环境）：确保以 / 开头
  if (!baseUrl.startsWith('/')) {
    baseUrl = '/' + baseUrl
  }
  
  if (fallbackUrl) {
    const encodedFallbackUrl = fallbackUrl
      .replace('?', 'AAA')
      .replace('#', 'BBB')
      .replace(/&/g, 'CCC')
    return `${baseUrl}?fallbackUrl=${encodedFallbackUrl}`
  }
  return baseUrl
}

// 密码登录（重定向方式）
export function redirectLogin2 (url) {
  const fallBackUrl = url
    .replace('?', 'AAA')
    .replace('#', 'BBB')
    .replace(/&/g, 'CCC')
  window.location.href = `${BasicConfig.loginShixin}?fallbackUrl=${fallBackUrl}`
}

/**
 * 当前网站的 ERP 票以本机 localStorage / Redux 为准。
 * test.awl.duobaby.net（主机名以 test. 开头）和 awl.duobaby.net 不共用父域 Cookie。
 * 返回 adopted：本机还没有票，用了当前主机 Cookie。
 */
export function alignHostErpToken () {
  const { token, user } = store.getState().app
  const cookieToken = Session.readHostIk()
  if (checkToken(token)) {
    if (cookieToken !== token) {
      Session.setIkCookie(token)
    }
    return 'kept'
  }
  if (cookieToken && checkToken(cookieToken)) {
    if (user && Object.keys(user).length > 0) {
      store.dispatch(appLogin({ token: cookieToken, user }))
    } else {
      store.dispatch(appLogin(cookieToken))
    }
    return 'adopted'
  }
  return 'kept'
}

export function login (jwt, callback) {
  // 如果url中带有jwt参数，更新jwt
  const { search, pathname, origin } = window.location

  const loginUrl = `${origin}/system/login`
  const query = parseQueryString(search)
  const sesstionToken = Session.getToken()
  const getCookie = Session.readHostIk()
  // 验证链接是否带有jwt
  const token = query.jwt || jwt
  if (checkToken(token)) {
    // 保存 token 及其创建时间（用于 7 天有效期验证）
    saveTokenWithTimestamp(token)
    Session.setIkCookie(token)
    store.dispatch(appLogin({ token: token }))
    delete query.jwt
    window.location.href = `${pathname}${objToSearch(query)}`
    return
  }

  // 获取cookiesjwt
  if (getCookie) {
    // 验证cookiesJWt 是否过期
    if (checkToken(getCookie)) {
      // cookies 与sesstion/redux jwt不一
      if (getCookie !== sesstionToken) {
        store.dispatch(appLogin(getCookie))
      }
      return callback()
    }
    // cookies jwt过期重新登陆
    window.location.href = loginUrl
    return
  }
  // 如果jwt已过期，重新登录
  if (Session.isExpired()) {
    window.location.href = loginUrl
    return
  }
  return callback()
}
